import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ITitleRequestState } from '../interfaces/ititle-request-status';

export const selectTitleRequestState = createFeatureSelector<ITitleRequestState>('titleRequest');

export const getState = createSelector(selectTitleRequestState, (state: ITitleRequestState) => state);

